import { render, staticRenderFns } from "./article-sup.vue?vue&type=template&id=8a0b677c&lang=pug&"
import script from "./article-sup.vue?vue&type=script&lang=js&"
export * from "./article-sup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports